import { Board, Product } from '../types';
import { calculatePriorityScore } from './priorityScore';

export const exportBoardToCSV = (board: Board, products: Product[]): void => {
  // Create CSV header
  const headers = [
    'Product Name',
    'Priority Score',
    'Status',
    'Description',
    'AI Summary',
    'GTM Ready %',
    'Effort Level',
    'Market Potential',
    'Features',
    'Competitors',
    'Created Date',
    'Updated Date'
  ];

  // Create CSV rows
  const rows = products.map(product => [
    product.name,
    product.priorityScore || calculatePriorityScore(product),
    product.status,
    product.description || '',
    product.aiSummary || '',
    product.gtmReadyPercent,
    product.effortLevel,
    product.marketPotential,
    product.features.join('; '),
    (product.competitors || []).join('; '),
    product.createdAt ? new Date(product.createdAt).toLocaleDateString() : 'Unknown date',
    product.updatedAt ? new Date(product.updatedAt).toLocaleDateString() : 'Unknown date'
  ]);

  // Combine headers and rows
  const csvContent = [headers, ...rows]
    .map(row => row.map(cell => `"${cell}"`).join(','))
    .join('\n');

  // Create and download file
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `${board.name}_products_${new Date().toISOString().split('T')[0]}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
